module.exports = __webpack_public_path__ + "images/fa-signup-bg.jpg";